import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-steptwo',
  templateUrl: './steptwo.component.html'
})
export class SteptwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
